export function formatDate(iso: string): string {
  // Datas sem hora ("2026-07-26") são parseadas como UTC pelo new Date(),
  // o que exibiria o dia anterior no fuso local — parse manual como data local.
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso)
  const d = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(iso)
  return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" })
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso)
  const date = d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" })
  const time = d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
  return `${date} ${time}`
}

/** Nota 0–10 com 1 casa decimal e vírgula: 7.4 → "7,4" */
export function formatScore(score: number): string {
  return score.toLocaleString("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
}

export function formatBRL(cents: number): string {
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
}

/** Segundos → "MM:SS" ou "H:MM:SS" */
export function formatClock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const mm = String(m).padStart(2, "0")
  const ss = String(sec).padStart(2, "0")
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`
}

/** Dias inteiros até uma data (ISO yyyy-mm-dd), contando a partir de hoje local. */
export function daysUntil(isoDate: string): number {
  const [y, m, d] = isoDate.split("-").map(Number)
  const target = new Date(y, m - 1, d)
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  return Math.max(0, Math.round((target.getTime() - today.getTime()) / 86_400_000))
}

/** Letra da alternativa: 0 → "A" */
export function letter(index: number): string {
  return String.fromCharCode(65 + index)
}

export function firstName(name: string | null, fallback: string): string {
  if (!name || name.trim() === "") return fallback
  return name.trim().split(/\s+/)[0]
}
